import { AxiosRestApplicationClient as OnboardingAxiosRestApplicationClient } from '@g2-shared/api-client/generated/onboarding-app';
import {
  getServerErrorMessage,
  LoggingServiceAdapter,
  NotificationAdapter,
} from '@g2-shared/common';
import { generateBaseAxiosClient } from '@g2-shared/common/libs/baseAxiosClient';

/* -------------- */
/*    QUESTIONNAIRE    */
/* -------------- */
export const FIND_QUESTIONNAIRE_SETS = 'FIND_QUESTIONNAIRE_SETS';
export const FIND_QUESTIONNAIRE_SET_BY_ID = 'FIND_QUESTIONNAIRE_SET_BY_ID';

export const FIND_QUESTIONNAIRE_SET_BY_APPLICATION_AND_SERVICE_CODE =
  'FIND_QUESTIONNAIRE_SET_BY_APPLICATION_AND_SERVICE_CODE';
export const FIND_QUESTIONNAIRE_SETS_BY_PARTY_TYPE_ID = 'FIND_QUESTIONNAIRE_SETS_BY_PARTY_TYPE_ID';
export const FIND_ALL_SUB_SERVICES = 'FIND_ALL_SUB_SERVICES';

export const questionnaireSetApiDefaultConfig = {
  retry: undefined,
  // cacheTime: Infinity,
};

export const useQuestionnaireSetApiDefaultConfig = (callerName: string) => {
  const { logError } = LoggingServiceAdapter();
  const { translateAndNotifyError } = NotificationAdapter();

  return {
    ...questionnaireSetApiDefaultConfig,
    onError: (error: unknown) => {
      translateAndNotifyError(getServerErrorMessage(error));
      logError(error, 'Error while calling questionnaire api', callerName);
    },
  };
};

/* -------------- */
/*      AXIOS     */
/* -------------- */
const { VITE_APP_GATEWAY_BASE_URL } = import.meta.env;

export const onboardingAxiosClient = new OnboardingAxiosRestApplicationClient(
  VITE_APP_GATEWAY_BASE_URL,
  generateBaseAxiosClient({ baseURL: VITE_APP_GATEWAY_BASE_URL })
);
